// 资金
// 财务

export default [

  /*  资金管理列表-待确认 */
  {
    path: '/remittanceToBeConfirmed',
    name: 'remittanceToBeConfirmed',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/remittanceToBeConfirmed/index.vue'),
    meta: {
      activeMenu: 'remittanceToBeConfirmed', // 可用选中菜单
    }
  },
  /*  资金管理列表-待确认 拷贝 */
  {
    path: '/remittanceToBeConfirmed_copy',
    name: 'remittanceToBeConfirmed_copy',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/remittanceToBeConfirmed_copy/index.vue'),
    meta: {
      activeMenu: 'remittanceToBeConfirmed_copy', // 可用选中菜单
    }
  },
  /*  资金管理列表-人工登记汇款 */
  {
    path: '/manualRegistrationAndRemittance',
    name: 'manualRegistrationAndRemittance',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/manualRegistrationAndRemittance/index.vue'),
    meta: {
      activeMenu: 'manualRegistrationAndRemittance', // 可用选中菜单
    }
  },
  /*  资金管理列表-已确认入金 */
  {
    path: '/theDepositHasBeenConfirmed',
    name: 'theDepositHasBeenConfirmed',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/theDepositHasBeenConfirmed/index.vue'),
    meta: {
      activeMenu: 'theDepositHasBeenConfirmed', // 可用选中菜单
    }
  },
  /*  资金管理列表-交易号付款 */
  {
    path: '/paymentByTransactionNumber',
    name: 'paymentByTransactionNumber',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/paymentByTransactionNumber/index.vue'),
    meta: {
      activeMenu: 'paymentByTransactionNumber', // 可用选中菜单
    }
  },
  /*  资金管理列表-客户提现 */
  {
    path: '/customerWithdrawal',
    name: 'customerWithdrawal',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/customerWithdrawal/index.vue'),
    meta: {
      activeMenu: 'customerWithdrawal', // 可用选中菜单
    }
  },
  /*  资金管理列表-客户提现 */
  {
    path: '/payPalCheck',
    name: 'payPalCheck',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/PayPalCheck/index.vue'),
    meta: {
      activeMenu: 'payPalCheck', // 可用选中菜单
    }
  },
  /*  资金管理列表-讲师提现 */
  {
    path: '/theLecturerWithdrawal',
    name: 'theLecturerWithdrawal',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '@/views/home/fundsManagement/theLecturerWithdrawal/index.vue'),
    meta: {
      activeMenu: 'theLecturerWithdrawal', // 可用选中菜单
    }
  },
  /*  售后列表 */
  {
    path: '/afterSale',
    name: 'afterSale',
    component: () => import( /* webpackChunkName: "afterSale" */ '@/views/home/afterSale/afterSaleList/index.vue'),
    meta: {
      activeMenu: 'afterSale', // 可用选中菜单
    }
  },
  /*  赔款单-列表 */
  {
    path: '/reparationList',
    name: 'reparationList',
    component: () => import( /* webpackChunkName: "afterSale" */ '@/views/home/afterSale/reparationList/index.vue'),
    meta: {
      activeMenu: 'reparationList', // 可用选中菜单
    }
  },

  /*  预留款-列表 */
  {
    path: '/earmarkedFund',
    name: 'earmarkedFund',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/earmarked_fund'),
    meta: {
      activeMenu: 'earmarkedFund', // 可用选中菜单
    }
  },
  /*  已付款客户订单(代购) */
  {
    path: '/account_paid',
    name: 'account_paid',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/account_paid/index'),
    meta: {
      activeMenu: 'account_paid', // 可用选中菜单
    }
  },
  /*  已付款客户订单(OEM) */
  {
    path: '/account_paid_OEM',
    name: 'account_paid_OEM',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/account_paid_OEM/index'),
    meta: {
      activeMenu: 'account_paid_OEM', // 可用选中菜单
    }
  },
  /*  预留款 */
  {
    path: '/earmarked_fund',
    name: 'earmarked_fund',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/earmarked_fund/index'),
    meta: {
      activeMenu: 'earmarked_fund', // 可用选中菜单
    }
  },
  /* 1688付款订单  */
  {
    path: '/1688PaymentOrder',
    name: '1688PaymentOrder',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/1688PaymentOrder/index'),
    meta: {
      activeMenu: '1688PaymentOrder', // 可用选中菜单
    }
  },
  /* 1688退款订单  */
  {
    path: '/1688RefundOrder',
    name: '1688RefundOrder',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/1688RefundOrder/index'),
    meta: {
      activeMenu: '1688RefundOrder', // 可用选中菜单
    }
  },
  /* 淘宝退款订单  */
  {
    path: '/taoBaoRefundOrder',
    name: 'taoBaoRefundOrder',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/taoBaoRefundOrder/index'),
    meta: {
      activeMenu: 'taoBaoRefundOrder', // 可用选中菜单
    }
  },
  /* 淘宝付款订单  */
  {
    path: '/taoBaoPaymentOrder',
    name: 'taoBaoPaymentOrder',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/financeLook/taoBaoPaymentOrder/index'),
    meta: {
      activeMenu: 'taoBaoPaymentOrder', // 可用选中菜单
    }
  },
  /* 入金信息汇总  */
  {
    path: '/depositInformation',
    name: 'depositInformation',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/depositInformation/index'),
    meta: {
      activeMenu: 'depositInformation', // 可用选中菜单
    }
  },
  /* 入金名义维护  */
  {
    path: '/depositNominalMaintenance',
    name: 'depositNominalMaintenance',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/depositNominalMaintenance/index'),
    meta: {
      activeMenu: 'depositNominalMaintenance', // 可用选中菜单
    }
  },
  /* 客户账单  */
  {
    path: '/clientBillList',
    name: 'clientBillList',
    component: () => import( /* webpackChunkName: "afterSale" */ '../../views/home/fundsManagement/clientBillList'),
    meta: {
      activeMenu: 'clientBillList', // 可用选中菜单
    }
  },
  /* 结汇列表  */
  {
    path: '/settlementList',
    name: 'settlementList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/settlementList'),
    meta: {
      activeMenu: 'settlementList', // 可用选中菜单
    }
  },
  /* 出入金变更  */
  {
    path: '/bill_adjust_apply',
    name: 'bill_adjust_apply',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/depositWithdrawalModification'),
    meta: {
      activeMenu: 'bill_adjust_apply', // 可用选中菜单
    }
  },
  /* 已退款待确认  */
  {
    path: '/refundedPendingConfirmation',
    name: 'refundedPendingConfirmation',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/refundedPendingConfirmation'),
    meta: {
      activeMenu: 'refundedPendingConfirmation', // 可用选中菜单
    }
  },
  /* 补货订单 */
  {
    path: '/replenishmentOrder',
    name: 'replenishmentOrder',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/replenishmentOrder/index'),
    meta: {
      activeMenu: 'replenishmentOrder', // 可用选中菜单
    }
  },
  /* 交易号平台支付比对列表 */
  {
    path: '/purchasePayCheckList',
    name: 'purchasePayCheckList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/purchasePayCheckList/index'),
    meta: {
      activeMenu: 'purchasePayCheckList', // 可用选中菜单
    }
  },
  /* 异常交易号跟进列表 */
  {
    path: '/purchaseNoNotInSystemList',
    name: 'purchaseNoNotInSystemList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/purchaseNoNotInSystemList/index'),
    meta: {
      activeMenu: 'purchaseNoNotInSystemList', // 可用选中菜单
    }
  },
  /* WordFirst异常核对-列表 */
  {
    path: '/worldfirstCheckList',
    name: 'worldfirstCheckList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/worldfirstCheckList/index'),
    meta: {
      activeMenu: 'worldfirstCheckList', // 可用选中菜单
    }
  },
  /* 交易号平台支付比对列表-待财务付款跟进 */
  {
    path: '/purchasePayCheckPurchaseList',
    name: 'purchasePayCheckPurchaseList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/purchasePayCheckPurchaseList/index'),
    meta: {
      activeMenu: 'purchasePayCheckPurchaseList', // 可用选中菜单
    }
  },
  /* 平台账单 */
  {
    path: '/platformBillList',
    name: 'platformBillList',
    component: () => import( /* webpackChunkName: "fundsManagement" */ '../../views/home/fundsManagement/platformBillList/index'),
    meta: {
      activeMenu: 'platformBillList', // 可用选中菜单
    }
  },
]